import React, {Component} from 'react';

export class Loading extends Component{
    render(){
        return(
            <div className={this.props.css} style={{minHeight: this.props.height, position: 'relative'}}>
                <div className="loading-logo"/>
            </div>
        )
    }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/components/loading.js